import React from "react";
import {
  EditOutlined, TagOutlined, HourglassOutlined, CheckCircleOutlined,
  DollarOutlined, PauseCircleOutlined, CloseCircleOutlined, TrophyOutlined,
} from "@ant-design/icons";
import watiLogo from "../../assets/wati_logo_only.png";

export const PIPELINE_COLUMNS = [
  {
    key: "in_chat",
    label: "All Chats",
    color: "#2979e8",
    icon: <img src={watiLogo} alt="WATI" style={{ width: 15, height: 15, objectFit: "contain", display: "inline-block" }} />,
    isChat: true,
  },
  { key: "draft",                         label: "Draft",                        color: "#8c8c8c", icon: <EditOutlined />,         statuses: ["draft"] },
  { key: "waiting_for_price",             label: "Waiting For Price",            color: "#2979e8", icon: <TagOutlined />,           statuses: ["waiting_for_price"] },
  { key: "waiting_customer_confirmation", label: "Waiting Confirmation",         color: "#e4a527", icon: <HourglassOutlined />,     statuses: ["waiting_customer_confirmation"] },
  { key: "confirmed_waiting_payment",     label: "Confirmed · Awaiting Payment", color: "#27b6b6", icon: <CheckCircleOutlined />,   statuses: ["confirmed_waiting_payment"] },
  // Post-paid execution (purchase/delivery) is managed on the Operations page;
  // here a paid card shows a fulfilment progress pill and jumps straight to
  // Completed when delivery finishes.
  { key: "paid",                          label: "Paid",                         color: "#5ab82c", icon: <DollarOutlined />,        statuses: ["paid", "waiting_purchase", "purchased", "out_for_delivery"] },
  { key: "completed",                     label: "Completed",                    color: "#459922", icon: <TrophyOutlined />,        statuses: ["completed", "delivered"] },
  { key: "parked",                        label: "Parked",                       color: "#8c8c8c", icon: <PauseCircleOutlined />,   statuses: ["on_hold", "postponed", "parked"] },
  { key: "cancelled",                     label: "Lost",                         color: "#e85658", icon: <CloseCircleOutlined />,   statuses: ["cancelled"] },
];

export function groupQueriesByStatus(tasks) {
  return PIPELINE_COLUMNS.reduce((acc, col) => {
    acc[col.key] = col.isChat ? [] : tasks.filter(t => col.statuses?.includes(t.status));
    return acc;
  }, {});
}

export const URGENCY_CFG = {
  1: { color: "#595959", pill: "#f0f0f0", cardBg: "transparent",              label: "1 · Low" },
  2: { color: "#2979e8", pill: "#e6f4ff", cardBg: "rgba(22,119,255,0.04)",    label: "2 · Normal" },
  3: { color: "#c5871c", pill: "#fffbe6", cardBg: "rgba(250,173,20,0.06)",    label: "3 · Medium" },
  4: { color: "#c54522", pill: "#fff2e8", cardBg: "rgba(255,122,0,0.08)",     label: "4 · High" },
  5: { color: "#c12733", pill: "#fff1f0", cardBg: "rgba(255,77,79,0.12)",     label: "5 · Critical" },
};
